export const Alignment = {
  leading: "flex-start",
  center: "center",
  trailing: "flex-end"
};

export const Colors = {
  red: "red",
  green: "green",
  blue: "blue",
  white: "white",
  gray: "gray",
  black: "black"
};
